import { render, staticRenderFns } from "./delivering.vue?vue&type=template&id=4a039186&scoped=true"
import script from "./delivering.vue?vue&type=script&lang=js"
export * from "./delivering.vue?vue&type=script&lang=js"
import style0 from "./delivering.vue?vue&type=style&index=0&id=4a039186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a039186",
  null
  
)

export default component.exports